import { render, staticRenderFns } from "./discountCoupon.vue?vue&type=template&id=22813ab6&scoped=true&"
import script from "./discountCoupon.vue?vue&type=script&lang=js&"
export * from "./discountCoupon.vue?vue&type=script&lang=js&"
import style0 from "./discountCoupon.vue?vue&type=style&index=0&id=22813ab6&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22813ab6",
  null
  
)

export default component.exports